import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

import { updateAppWidth } from "../store/appSlice";
import { setHeaderMobile } from "../store/headerSlice";
import { get } from "../store/selectors";

export const useResponsive = () => {
	const dispatch = useDispatch();
	useEffect(() => {
		const updateScreenWidth = () => {
			dispatch(updateAppWidth());
			dispatch(setHeaderMobile());
		};
		const onOrientationchange = () => {
			const scale = window.visualViewport?.scale || 1;
			if (scale < 1.01) {
				// Fix zoom bug on PWA safari orientation change
				document.body.style.zoom = 1 / scale;
				setTimeout(() => {
					document.body.style.zoom = 1;
				}, 300);
			}

			updateScreenWidth();
		};
		window.addEventListener("resize", updateScreenWidth);
		window.addEventListener("orientationchange", onOrientationchange);

		return () => {
			window.removeEventListener("resize", updateScreenWidth);
			window.removeEventListener("orientationchange", onOrientationchange);
		};
	}, [dispatch]);

	const appWidth = useSelector(get.appWidth);
	return appWidth;
};
